import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService} from '../../_services/auth.service';
import { StorageService } from '../../_services/storage.service';
import { UserService} from '../../_services/user.service';

import { NotificationService} from '../../_services/notification.service';

import { Router} from '@angular/router';
import { LostPasswordRequestDto } from '../../_services/auth.dto';
@Component({
    selector: 'app-lostpassword',
    templateUrl: './lostpassword.component.html',
    styleUrl: './lostpassword.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LostpasswordComponent implements OnInit{
  loginForm!: FormGroup;
  passwordRegex = '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$';
  passwordValidator = Validators.pattern(this.passwordRegex);
  isLoggedIn = false;
  isLoginFailed = false;
  errorMessage = '';
  isSubmitted = false;
  constructor(
    private formBuilder: FormBuilder,
    private auth:AuthService,
    private router:Router,
    private storageService:StorageService,
    private userService:UserService,
    private notificationService:NotificationService

  ) { }

  ngOnInit() {
    this.initialiserFormulaire();
  }

  initialiserFormulaire() {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  login() {
    if (this.loginForm.valid) {

      const username = this.loginForm.get('email')?.value

      this.auth.lostpassword(username).subscribe({
        next: () => {
          this.notificationService.addNotification({
            type: 'success',
            message: 'Votre demande a été traitée.',
          })
          this.isSubmitted = true;

          setTimeout(() => {
            this.router.navigateByUrl('/login').then(() => {});
          }, 10000);

        },
        error: (err: { status: number; error: { message: string; }; }) => {
          this.loginForm.get('username')?.reset();
          if (err.status == 423){
            this.notificationService.addNotification({
              type: 'alert',
              message: 'Votre compte a été bloqué, merci de contacter un administrateur',
            })
          } else{
            this.notificationService.addNotification({
              type: 'alert',
              message: 'Une erreur est survenie. Votre demande n\'a pas été traitée',
            })
          }

        }
      }
      )

    } else {
      this.notificationService.addNotification({
        type: 'alert',
        message: 'Merci de compléter le formulaire.',
      })
    }
  }

}
